<template>
  <div>
    <div v-if="displayCutOff">
      G : {{ $systemUnits.convertGrade(grade, element) | toFriendlyGrade }} / C : {{$systemUnits.convertGrade(cutoff, element) | toFriendlyGrade }}
    </div>
    <div v-if="displayGrade">
      {{ $systemUnits.convertGrade(this.grade, element) | toFriendlyGrade }}
    </div>
    <div v-else></div>
  </div>
</template>

<script>
export default {
  name: 'ForecastResultCellRenderer',
  data() {
    return {
      grade: null,
      cutoff: null,
      element: null
    }
  },
  created() {
    this.grade = this.params.value.grade;
    this.cutoff = this.params.value.cutOff;
    this.element = this.params.value.element;
  },
  
  computed: {
    displayCutOff() {
      return typeof this.cutoff !== 'undefined' && this.cutoff !== null && !this.cutoff !== '';
    },
    displayGrade() {
      return this.grade > 0;
    }
  }
}
</script>
